import { PeriodChangeListChart, PeriodChangeListChartProps } from '../../../renderers/period-change-list-chart/period-change-list-chart.component';
import { FILL_RATE_BY_PRODUCT_MONTHLY_LIST_CHART_DEFINITION } from './fill-rate-by-product-monthly-list-chart.definition';
import { FILL_RATE_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA } from './fill-rate-by-product-monthly-list-chart.mock';

export const FillRateByProductMonthlyListChart = (props: PeriodChangeListChartProps) => <PeriodChangeListChart {...props} />;

FillRateByProductMonthlyListChart.definition = FILL_RATE_BY_PRODUCT_MONTHLY_LIST_CHART_DEFINITION;
FillRateByProductMonthlyListChart.mockData = FILL_RATE_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA;
